import moment from "moment";

export interface TaxInvoice {
    property1: string;
    property2: number;
    // add more properties as needed
}

export interface FormData {
    receiptnumber: string;
    tel: string;
    alignment: 'enterprise' | 'personal';
    TaxCompany: string;
    TaxPersonal: string;
    TaxNo: string;
    TaxEmail?: string;
    TaxAmount?: number | string;
    TaxRemark?: string;
    RECEIPTAMOUNT?: number;
    RECEIPTDATE?: string;
    MEMBERNAME?: string;
    SHOPNAME?: string;
    MEMBERCODE?: string;
    INVOICEDATE?: string;
    INVOICENUMBER?: string;
    SHOPID?: number,
    [key: string]: string | number | undefined;
}

export const InvoiceFormCreateRequiredFields = {
    enterprise: ['TaxCompany', 'TaxNo', 'TaxEmail', 'TaxAmount'],
    personal: ['TaxPersonal', 'TaxEmail', 'TaxAmount'],
}

// Define the options outside of the function to avoid recreating them on each call
const invoiceFormOptions = {
    enterprise: {
        value: 'enterprise',
        label: 'invoiceForm.text.enterprise'
    },
    personal: {
        value: 'personal',
        label: 'invoiceForm.text.personal'
    },
};

// Freeze the options object to prevent modification
const invoiceFormToggleOptions = Object.freeze(invoiceFormOptions);

export { invoiceFormToggleOptions };

export const isEnterpriseSelectionRestricted = (SHOPID?: number, SHOPNAME?: string, INVOICEDATE?: string): boolean => {
    const restrictedShops = {
        ids: [202],
        names: ['廣州-五月花2F PMNB'],
        date: '2024-07-01',
    };

    const isRestrictedById = SHOPID !== undefined && restrictedShops.ids.includes(SHOPID);
    const isRestrictedByName = SHOPNAME ? restrictedShops.names.includes(SHOPNAME) : false;
    const isDateRestricted = INVOICEDATE ? moment(INVOICEDATE).isSameOrAfter(restrictedShops.date) : false;
    return isDateRestricted && (isRestrictedById || isRestrictedByName);
};

export const getInvoiceFormToggleOptions = ({ isToggleRestricted }: { isToggleRestricted:boolean }) => {
    // Return only the personal option if either condition is met
    if (isToggleRestricted) {
        return { personal: invoiceFormToggleOptions.personal };
    }

    // Return the original, frozen options object otherwise
    return invoiceFormToggleOptions;
}